import type { Currency } from '@/types/payment'

export function parseDepositAmount(amount: string): number | null {
	const trimmedAmount = amount.trim()
	if (!trimmedAmount) {
		return null
	}

	const parsedAmount = Number(trimmedAmount)
	if (!Number.isFinite(parsedAmount) || parsedAmount <= 0) {
		return null
	}

	return parsedAmount
}

export function isValidDepositAmount(amount: string, currency: Currency | null | undefined): boolean {
	if (!currency) {
		return false
	}

	const parsedAmount = parseDepositAmount(amount)
	if (parsedAmount === null) {
		return false
	}

	const minDeposit = Number(currency.min_deposit)
	if (Number.isFinite(minDeposit) && parsedAmount < minDeposit) {
		return false
	}

	const maxDeposit = Number(currency.max_deposit)
	if (Number.isFinite(maxDeposit) && maxDeposit > 0 && parsedAmount > maxDeposit) {
		return false
	}

	return true
}

export function formatCurrencyLabel(currency: Currency): string {
	return `${currency.currency_code} ( ${currency.network} )`
}
